import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import HeaderNavbar from "../Component/Navbar";
import Footer from "../Component/Footer";
import mrg from "../assets/marriage.jpeg";

export default function About() {
  return (
    <>
      <HeaderNavbar />

      {/* PAGE HEADER */}
      <div
        style={{
          background: "#f8f5f2",
          padding: "60px 0",
          textAlign: "center",
        }}
      >
        <h1 style={{ color: "#7b1e3b", fontWeight: "600" }}>About Us</h1>

        <p style={{ color: "#666", marginTop: "10px" }}>
          Connecting hearts with trust, tradition and technology
        </p>
      </div>

      {/* ABOUT SECTION */}
      <Container style={{ padding: "70px 0" }} className="my-2">
        <Row className=" align-items-center">
          <Col lg={6}>
            <h2 style={{ color: "#5a1424", fontWeight: "600" }} className="mx-4">
              Welcome to KVL Matrimony
            </h2>

            <p style={{ marginTop: "15px", color: "#555", lineHeight: "1.7" }} className="mx-4">
              KVL Matrimony is yet another trusted initiative of the Karnataka Veerashaiva Lingayat (KVL) platform committed to the welfare, empowerment and holistic development of the Veerashaiva Lingayat community.

            </p>

            <p style={{ color: "#555", lineHeight: "1.7" }} className="mx-4">
              KVL platform brings together a distinguished network of members, including teachers, professionals, entrepreneurs and officers serving at State and All India levels, such as IAS, IPS, KAS etc cutting across different departments. Inspired by the timeless principles of Basava Tattva and the rich spiritual and cultural heritage of the Veerashaiva-Lingayat tradition, the platform works to strengthen the community through initiatives such as the KVL Credit Cooperative Society, KVL Housing Society, KVL Academy, KVL Matrimony, among others.
            </p>


          </Col>

          <Col lg={6} >
            <img
              src={mrg}
              alt="Hindu wedding couple"
              className="mx-3"
              style={{
                width: "90%",
                height: "420px",
                objectFit: "cover",
                borderRadius: "14px",
                boxShadow: "0 12px 30px rgba(0,0,0,0.15)",
              }}
            />
          </Col>
        </Row>
      </Container>

      {/* MISSION VISION */}
      <div style={{ background: "#fafafa", padding: "70px 0" }}>
        <Container>
          <Row>
            <Col md={6} className="my-2">
              <div
                style={{
                  background: "#fff",
                  padding: "30px",
                  borderRadius: "10px",
                  boxShadow: "0 5px 20px rgba(0,0,0,0.06)",
                  height: "100%",
                }}


              >
                <h4 style={{ color: "#7b1e3b" }}>Our Mission</h4>

                <p style={{ color: "#555", marginTop: "15px" }}>
                  Our mission is to foster strong families and a progressive society by promoting genuine, value-based relationships while preserving the cultural legacy and enduring ideals of the Veerashaiva-Lingayat community.
                </p>
              </div>
            </Col>

            <Col md={6} className="my-2">
              <div
                style={{
                  background: "#fff",
                  padding: "30px",
                  borderRadius: "10px",
                  boxShadow: "0 5px 20px rgba(0,0,0,0.06)",
                  height: "100%",
                }}

              >
                <h4 style={{ color: "#7b1e3b" }}>Our Vision</h4>

                <p style={{ color: "#555", marginTop: "15px" }}>
                  KVL Matrimony is established with the vision of helping individuals and families to find compatible life partners based on shared values, traditions, education and aspirations. The initiative combines modern technology with trust, transparency and community values to provide a secure and reliable platform for meaningful matrimonial alliances.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* WHY CHOOSE US */}
      <Container style={{ padding: "70px 0" }}>
        <Row className="text-center mb-5">
          <Col>
            <h2 style={{ color: "#5a1424" }}>Why Choose KVL Matrimony?</h2>
          </Col>
        </Row>

        <Row className="text-center">
          <Col md={4}>
            <div style={{ padding: "20px" }}>
              <h5 style={{ color: "#7b1e3b" }}>Verified Profiles</h5>
              <p style={{ color: "#666" }}>
                We ensure all profiles go through verification to maintain
                authenticity and trust.
              </p>
            </div>
          </Col>

          <Col md={4}>
            <div style={{ padding: "20px" }}>
              <h5 style={{ color: "#7b1e3b" }}>Privacy & Security</h5>
              <p style={{ color: "#666" }}>
                Your personal information is protected with strong privacy and
                security measures.
              </p>
            </div>
          </Col>

          <Col md={4}>
            <div style={{ padding: "20px" }}>
              <h5 style={{ color: "#7b1e3b" }}>Smart Matchmaking</h5>
              <p style={{ color: "#666" }}>
                Our platform helps you discover compatible matches quickly and
                easily.
              </p>
            </div>
          </Col>
        </Row>
      </Container>

      <Footer />
    </>
  );
}
